import React from "react";

export default function RedLine(props: any) {
  return <div className={"bg-main w-[80px] h-[4px]"}></div>;
}
